import React from 'react';

import { Form } from 'antd';

import { Select } from '@element/index'
import { I18n } from '@utils/index';

import styles from './index.module.less';

const { Item } = Form;

export const validDateList = [
  {
    label: '24H',
    value: 1
  },
  {
    label: '48H',
    value: 2
  },
  {
    label: '72H',
    value: 3
  },
  {
    label: '120H',
    value: 5
  }
];

interface SelectValidPeriodProps {
  className?: string;
  name: string;
}

export const SelectValidPeriod: React.FC<SelectValidPeriodProps> = (props) => {
  const { name, className } = props;
  return (
    <Item className={className} shouldUpdate={(prevValues, curValues) => {
      return prevValues[name] !== curValues[name]
    }}>
      {(form) => {
        return (
          <Item name={name} className={styles.item}>
            <div className={styles.container}>
              <span className={styles.label}>{I18n.t('oVQxK55O')}</span>
              <Select
                className={styles.select}
                value={form.getFieldValue(name)}
                theme="dark"
                options={validDateList}
                onChange={params => {
                  form.setFieldValue(name, params.value)
                  console.log('line 26', params)
                }}
                selectBtnCalssName={styles.selectBtn}
                popoverClass={styles.popover}
              />
            </div>
          </Item>
        );
      }}
    </Item>
  );
}
